import React from 'react';
import { PageHeader } from '../components/dashboard/PageHeader';
import { Card, CardContent, CardHeader, CardTitle } from '../components/Card';
import { ShieldAlert, MapPin, Clock, AlertTriangle, Shield, Crosshair } from 'lucide-react';
import { Badge } from '../components/Badge';
import { Button } from '../components/Button';
import { Table, TableHeader, TableBody, TableRow, TableHead, TableCell } from '../components/Table';
import { toast } from 'sonner';
const threats = [{
  id: 'TRT-001',
  type: 'Phishing & Impersonation',
  target: 'Akun Resmi Presiden',
  source: 'IP: 192.168.x.x (Proxy)',
  severity: 'TINGGI',
  status: 'INVESTIGASI'
}, {
  id: 'TRT-002',
  type: 'Doxxing',
  target: 'Aparat Keamanan (Papua)',
  source: 'Grup Telegram Anonim',
  severity: 'KRITIS',
  status: 'ESKALASI'
}, {
  id: 'TRT-003',
  type: 'Malware Campaign',
  target: 'Situs Kementerian X',
  source: 'Botnet Teridentifikasi',
  severity: 'SEDANG',
  status: 'MITIGASI'
}, {
  id: 'TRT-004',
  type: 'Physical Threat Intel',
  target: 'Rute Kunjungan VVIP',
  source: 'Analisis Sentimen Ekstrem',
  severity: 'TINGGI',
  status: 'MONITORING'
}];
export function ThreatIntel() {
  const handleAction = (action: string, id: string) => {
    toast.success(`Tindakan: ${action}`, {
      description: `Perintah dieksekusi untuk ancaman ${id}.`
    });
  };
  return <div className="mx-auto flex w-full max-w-[1600px] flex-col gap-6" data-id="element-3464">
      <PageHeader group="Ancaman & Proteksi" title="Threat Intelligence" description="Pemantauan ancaman siber, fisik, dan reputasi secara real-time." icon={ShieldAlert} extraActions={<Button variant="destructive" size="sm" onClick={() => toast.error('Protokol Darurat Diaktifkan', {
      description: 'Semua akses VVIP diperketat.'
    })} data-id="element-3466">
            <AlertTriangle className="size-4 mr-2" data-id="element-3467" />
            Aktifkan Protokol Darurat
          </Button>} data-id="element-3465" />

      <div className="grid grid-cols-1 md:grid-cols-3 gap-4" data-id="element-3468">
        <Card className="bg-red-500/10 border-red-500/30" data-id="element-3469">
          <CardContent className="p-6 flex flex-col items-center justify-center text-center" data-id="element-3470">
            <ShieldAlert className="size-8 text-red-500 mb-2" data-id="element-3471" />
            <span className="font-heading text-4xl font-bold text-red-500" data-id="element-3472">
              3
            </span>
            <span className="font-mono text-xs text-red-500/80 mt-1" data-id="element-3473">
              ANCAMAN KRITIS AKTIF
            </span>
          </CardContent>
        </Card>
        <Card className="bg-amber-500/10 border-amber-500/30" data-id="element-3474">
          <CardContent className="p-6 flex flex-col items-center justify-center text-center" data-id="element-3475">
            <Crosshair className="size-8 text-amber-500 mb-2" data-id="element-3476" />
            <span className="font-heading text-4xl font-bold text-amber-500" data-id="element-3477">
              12
            </span>
            <span className="font-mono text-xs text-amber-500/80 mt-1" data-id="element-3478">
              TARGET IDENTIFIED
            </span>
          </CardContent>
        </Card>
        <Card className="bg-emerald-500/10 border-emerald-500/30" data-id="element-3479">
          <CardContent className="p-6 flex flex-col items-center justify-center text-center" data-id="element-3480">
            <Shield className="size-8 text-emerald-500 mb-2" data-id="element-3481" />
            <span className="font-heading text-4xl font-bold text-emerald-500" data-id="element-3482">
              98%
            </span>
            <span className="font-mono text-xs text-emerald-500/80 mt-1" data-id="element-3483">
              SYSTEM DEFENSE RATE
            </span>
          </CardContent>
        </Card>
      </div>

      <Card className="bg-card border-border/50" data-id="element-3484">
        <CardHeader className="border-b border-border/50" data-id="element-3485">
          <CardTitle className="font-mono text-sm uppercase tracking-wider text-foreground" data-id="element-3486">
            Active Threat Log
          </CardTitle>
        </CardHeader>
        <CardContent className="p-0" data-id="element-3487">
          <div className="overflow-x-auto" data-id="element-3488">
            <Table data-id="element-3489">
              <TableHeader className="bg-muted/20" data-id="element-3490">
                <TableRow className="border-border/50" data-id="element-3491">
                  <TableHead className="font-mono text-[10px]" data-id="element-3492">ID</TableHead>
                  <TableHead className="font-mono text-[10px]" data-id="element-3493">
                    TIPE ANCAMAN
                  </TableHead>
                  <TableHead className="font-mono text-[10px]" data-id="element-3494">
                    TARGET
                  </TableHead>
                  <TableHead className="font-mono text-[10px]" data-id="element-3495">
                    SUMBER/VEKTOR
                  </TableHead>
                  <TableHead className="font-mono text-[10px]" data-id="element-3496">
                    SEVERITY
                  </TableHead>
                  <TableHead className="font-mono text-[10px]" data-id="element-3497">
                    STATUS
                  </TableHead>
                  <TableHead className="font-mono text-[10px] text-right" data-id="element-3498">
                    AKSI
                  </TableHead>
                </TableRow>
              </TableHeader>
              <TableBody data-id="element-3499">
                {threats.map(t => <TableRow key={t.id} className="border-border/30" data-id="element-3500">
                    <TableCell className="font-mono text-xs" data-id="element-3501">{t.id}</TableCell>
                    <TableCell className="text-xs font-medium" data-id="element-3502">
                      {t.type}
                    </TableCell>
                    <TableCell className="text-xs text-muted-foreground" data-id="element-3503">
                      {t.target}
                    </TableCell>
                    <TableCell className="font-mono text-[10px] text-muted-foreground" data-id="element-3504">
                      {t.source}
                    </TableCell>
                    <TableCell data-id="element-3505">
                      <Badge variant="outline" className={`font-mono text-[9px] border-none ${t.severity === 'KRITIS' ? 'bg-red-500/20 text-red-500' : t.severity === 'TINGGI' ? 'bg-amber-500/20 text-amber-500' : 'bg-blue-500/20 text-blue-500'}`} data-id="element-3506">
                        {t.severity}
                      </Badge>
                    </TableCell>
                    <TableCell data-id="element-3507">
                      <span className="font-mono text-[10px] text-muted-foreground" data-id="element-3508">
                        {t.status}
                      </span>
                    </TableCell>
                    <TableCell className="text-right" data-id="element-3509">
                      <Button variant="outline" size="xs" className="h-6 text-[9px] font-mono mr-2" onClick={() => handleAction('Investigasi Lanjut', t.id)} data-id="element-3510">
                        Investigasi
                      </Button>
                      <Button variant="default" size="xs" className="h-6 text-[9px] font-mono bg-red-600 hover:bg-red-700" onClick={() => handleAction('Blokir Vektor', t.id)} data-id="element-3511">
                        Blokir
                      </Button>
                    </TableCell>
                  </TableRow>)}
              </TableBody>
            </Table>
          </div>
        </CardContent>
      </Card>
    </div>;
}